var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['bot-image-message']] = true, _obj[_vm.$style['bot-image-message-without-buttons']] = !_vm.hasButtons, _obj )},[_c('img',{attrs:{"src":_vm.content.url,"alt":_vm.content.extra ? _vm.content.extra.alt : ''},on:{"load":function($event){return _vm.registerIsLoaded()}}}),_vm._t("buttonsContainer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }